import { Component, OnInit, ElementRef, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UserManagerService } from '../shared/providers/user-manager.service';
import { IUserDetails } from '../shared/models/UserDetailsOutputModel';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { RestService } from '../shared/providers/rest.service'
import { IStatesList } from '../shared/models/StatesListOutputModel'
import { IUserInput } from '../shared/models/UserInputModel';
import { ICities } from '../shared/models/CitiesListOutputModel'
import { IUserRole } from '../shared/models/UserRoleOutputModel';
import { ILookUp } from '../shared/models/LookUpOutputModel';
import { IBrokerRegionalLicenses } from '../shared/models/BrokerRegionalLicensesInputModel';
import { IUserCreationResponseModel } from '../shared/models/UserCreationResponseModel';
import { FileUploadService } from '../shared/providers/fileupload.service';
import { IFileUpload } from '../shared/models/fileupload';
import { ValidationService } from '../shared/providers/validation.service';
import { ToastService } from '../shared/providers/toast.service'
import { CommonService } from '../shared/providers/common.service'
import { UserStatus } from '../shared/enum/enum';
import { LoaderService } from '../shared/providers/loader.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UserRole } from '../shared/enum/enum';
import { AuthenticationService } from '../shared/auth/authentication.service';
import { BrokerageManagerService } from '../shared/providers/brokerage-manager.service';
import { IBrokerageInput } from '../shared/models/Brokerageinputmodel';
import { AuthService } from '../shared/auth/auth.service';
import { ForgotPasswordService } from '../shared/providers/forgot-password.service';
import { IForgotPassword } from '../shared/models/forgotpasswordInput';
import { PermissionService } from '../shared/providers/permission.service';
import { Actions, Modules } from '../shared/enum/enum';


@Component({
  selector: 'user-add',
  templateUrl: './user-add.component.html',

})
export class UserAddComponent implements OnInit {

  Modules = Modules;
  Actions = Actions;
  statesList: IStatesList[];
  citiesList: ICities[];
  brokeragesList: number[];
  userRoleList: IUserRole[];
  lookupList: ILookUp[];
  userInputModel = {} as IUserInput;
  userCreationResponseModel = {} as IUserCreationResponseModel;
  fileUploadType: string = "single";
  inputFileUpload = {} as IFileUpload;
  showUpdatePassword = false;
  DefaultIndexCount: number = 0;
  userGuid: string = "0";
  userDetailsOutput = {} as IUserDetails;
  inputBrokerage = [];
  brokerageList = {} as IBrokerageInput;
  IsEditMode: boolean = false;
  IsAdd: boolean = false;
  @ViewChild('profilePic') profilePic: ElementRef;
  pageHeading = "Add Employee Details";
  userRole = UserRole;
  brokerRegionalLicenses: Array<IBrokerRegionalLicenses> = [];
  private newAttribute: any = {};
  imageIdToDelete: number;
  deleteTask: string;
  deleteTaskId: number;
  modalRef: BsModalRef;
  userId: number = 0;
  IsExistingBroker: boolean = false;
  isExpiryDateValidate: number[] = [];
  newUserPassword = '';
  confirmPassword = '';
  loggedUserDetails: any;
  forgotPasswordModel = {} as IForgotPassword;
  isDisableRole = true;
  defaultBrokerageSettings = {
    singleSelection: false,
    text: "Select",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    classes: "myclass custom-class",
    enableFilterSelectAll: false,
    badgeShowLimit: 1
  };
  //defaultBrokerageText: IMultiSelectTexts = {
  //    checked: 'item selected',
  //    checkedPlural: 'items selected',
  //    defaultTitle: 'Select'
  //};
  userEmailID: string;
  IsBlocked: boolean = false;
  IsDeleted: boolean = false;
  isDisabled = true;

  constructor(private _brokerageManagerService: BrokerageManagerService, public permissionService: PermissionService, private forgotPasswordService: ForgotPasswordService, private _restService: RestService, private _userManagerService: UserManagerService, private _fileUploadService: FileUploadService, private router: Router, public validationService: ValidationService,
    private activatedRoute: ActivatedRoute, private _toastService: ToastService, private _commonService: CommonService, protected loaderService: LoaderService, private modalService: BsModalService,
    private authService: AuthenticationService, public _validationService: ValidationService, private _auth0: AuthService) {

    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.userGuid = params['user'];
      if (this.userInputModel.ProfilePicPath === undefined || this.userInputModel.ProfilePicPath === null || this.userInputModel.ProfilePicPath.trim().length <= 0) {
        this.userInputModel.ProfilePicPath = '/../../../assets/img/default-profile-img.png'
      }
    });
  }
  result = [];

  deleteBrokerage(id: number, index: number) {

    this.result.splice(index, 1);
    for (var i = 0; i < this.userInputModel.BrokerageId.length; i++) {
      if (this.userInputModel.BrokerageId[i] === id) {
        this.userInputModel.BrokerageId.splice(i, 1);
      }
    }
  }
  addOrEditBrokerage() {
    this.result = [];
    this.userInputModel.BrokerageId.forEach(item => {
      this._brokerageManagerService.getBrokerageDetails(item).subscribe(response => {

        this.result.push(response);
      });
    });
    this.modalRef.hide();
  }

  addFieldValue() {
    this.brokerRegionalLicenses.push(this.newAttribute)
    this.newAttribute = {};

    //setting state drop down value as  --select---
    for (let i = 0; i < this.brokerRegionalLicenses.length; i++) {
      if ((i + 1) == this.brokerRegionalLicenses.length) {
        this.brokerRegionalLicenses[i].StateId = 0;
      }
    }
  }

  openModalBrokerage(template: TemplateRef<any>, classes: any) {
    this.modalRef = this.modalService.show(template, { class: classes });
  }


  openModalChangePassword(template: TemplateRef<any>, classes: any) {
    this.confirmPasswordValidation = '';
    this.isDisabled = false;
    this.passwordValidation = '';
    this.passwordValid = true;
    this.newUserPassword = '';
    this.confirmPassword = '';
    const config = {
      ignoreBackdropClick: true,
      class: classes,
      keyboard: false,
      backdrop: true
    }
    this.modalRef = this.modalService.show(template, config);
  }
  saveBrokerageList = [];
  //selectedBrokerages() {

  //    this.saveBrokerageList = [];
  //    let result = "";
  //    this.userInputModel.BrokerageId.forEach(item => {
  //        result += this.inputBrokerage.find(x => x.id === item).name + ", ";
  //    });
  //    result = this._validationService.removeLastCharacterFromString(result);

  //}

  deleteFieldValue(index: any, Id: number) {
    if (Id !== undefined) {
      this._userManagerService.CheckBrokerLicenseUsed(Id).subscribe(response => {
        if (response) {
          this._toastService.addToast({ title: 'Error Occurred', msg: 'Can not delete this license since it is already used in a propery.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
        }
        else {
          this.brokerRegionalLicenses.splice(index, 1);
        }
      });
    }
    else {
      this.brokerRegionalLicenses.splice(index, 1);
    }
  }

  selectedFiles: string[] = [];
  clearFiles: number = 0;

  selectedFilesListEmitter(selectedFilesListEmitter: string[]) {
    this.selectedFiles = selectedFilesListEmitter;
  }

  selectedFilePathEmitter(selectedFilePathEmitter: any) {
    this.profilePic.nativeElement.src = selectedFilePathEmitter;
  }

  setUploadDefaultValues() {
    this.inputFileUpload.fileCategoryId = 251;
    this.inputFileUpload.id = 0;
    this.inputFileUpload.objectId = 0;
    this.inputFileUpload.objectTypeId = 301;
    this.inputFileUpload.documentName = "User Profile Pictuer";
    this.inputFileUpload.type = "Images";
  }
  onKeydown(event) {
    if (event.key === "Enter") {
      this.saveUser();
    }
  }

  uploadFiles() {

    this._fileUploadService.uploadFiles(this.inputFileUpload, this.selectedFiles).subscribe(response => {
      this.clearFiles++;
      this.redirectToListingPage();
    });
  }
  wasComplianceBroker = false;
  validatePassword = false;
  ngOnInit() {
    this._brokerageManagerService.getBrokerageList().subscribe(response => {
      if (response != null && response.length > 0) {

        this.inputBrokerage = response.map(o => { return { id: o.Id, name: o.BrokerageName }; });
      }
    });

    this.authService.isLoggedIn.subscribe(response => {
      if (response) {
        this.loggedUserDetails = this.authService.user;
        this.userInputModel.CreatedById = this.loggedUserDetails.Id;
      }
    });

    this.setUploadDefaultValues();
    this._commonService.getStateList().subscribe(response => {
      this.statesList = response.map(o => { return { Id: o.Id, Name: o.StateName }; });
    });


    this._commonService.getLookupsByTypeId(1).subscribe(response => {
      this.lookupList = response.filter(x => x.Id != 103 && x.Id != 104).map(o => { return { id: o.Id, description: o.Description }; });
    });

    this.userInputModel.StateId = 0;
    this.userInputModel.CityId = 0;
    this.userInputModel.UserRoleId = 0;
    this.userInputModel.UserStatus = 0;

    if (this.userGuid != undefined) {
      this._userManagerService.getUserDetails(this.userGuid).subscribe(response => {
        this.userEmailID = response.Email;
        if (this.permissionService.hasPermission(Modules.Employees, Actions.ChangePassword)) {
          if (response.UserRoleId === this.userRole.ComplianceBroker) {
            this.showUpdatePassword = false;

          }
          else {
            this.showUpdatePassword = true;
          }
        }
        else {
          this.showUpdatePassword = false;
        }
        this.userInputModel.UserGuid = this.userGuid;
        this.userInputModel.IsDefaultSuperAdmin = response.IsDefaultSuperAdmin;
        this.userInputModel.UserRoleId = response.UserRoleId;
        this.loadUserRoles();
        this.userInputModel.FirstName = response.FirstName;
        this.userInputModel.FirstName = response.FirstName;
        this.userInputModel.LastName = response.LastName;
        this.userInputModel.EmailAddress = response.Email;
        this.userInputModel.PhoneNumber = response.Phoneno;
        this.userInputModel.Address1 = response.Address1;
        this.userInputModel.Address2 = response.Address2;
        this.userInputModel.StateId = response.StateId;
        this.bindCity();
        this.userInputModel.CityId = response.CityId == null ? 0 : response.CityId;
        this.userInputModel.Zip = response.Zip;
        this.userInputModel.UserStatus = response.UserStatusId;
        this.userInputModel.ProfilePicPath = response.ProfilePicPath;
        if (this.userInputModel.UserRoleId == this.userRole.Broker ||
          this.userInputModel.UserRoleId == this.userRole.SuperAdmin ||
          this.userInputModel.UserRoleId == this.userRole.Admin
        ) {
          this.userInputModel.UserLinkedInProfile = response.UserLinkedInProfile;
        }

        if (this.userInputModel.UserRoleId !== this.userRole.ComplianceBroker) {
          this.userInputModel.Password = '***********************************************************************';
        }
        else {
          this.wasComplianceBroker = true;
        }
        this.userInputModel.CompanyName = response.CompanyName;
        this.imageIdToDelete = response.ImageId;
        if (this.imageIdToDelete != null) {
          $('.profileupload')[0].hidden = true;
        }
        else {
          $('.profileupload')[0].hidden = false;
        }
        this.userId = response.Id;
        this._userManagerService.checkIsActiveBroker(this.userId).subscribe(response => {
          if (response.toString() === 'true') {
            this.IsExistingBroker = true;
          }
        });

        if (response.BrokerRegionalLicensesOutputModelList !== null) {
          //Converting  UTC Date into Local Date
          for (let i = 0; i < response.BrokerRegionalLicensesOutputModelList.length; i++) {
            let UTCDate = (response.BrokerRegionalLicensesOutputModelList[i].ExpiryDate);

            if (!this.validationService.IsinValid(UTCDate)) {
              var date = new Date(UTCDate + ' UTC');
              response.BrokerRegionalLicensesOutputModelList[i].ExpiryDate_Date = date;
            }
          }
        }

        this.brokerRegionalLicenses = response.BrokerRegionalLicensesOutputModelList;
        this.validateExpirationDate();

        this.IsEditMode = true;
        this.pageHeading = "Edit Employee Details";

        if (this.userInputModel.ProfilePicPath === undefined || this.userInputModel.ProfilePicPath === null || this.userInputModel.ProfilePicPath.trim().length <= 0) {
          this.userInputModel.ProfilePicPath = '/../../../assets/img/default-profile-img.png'
        }


        if (this.userInputModel.UserRoleId == this.userRole.DataEntryStaff) {
          this.userInputModel.BrokerageId = [];
          this._userManagerService.getBrokerages(this.userId).subscribe(response => {
            if (response != null) {
              this.result = response;

              //this.inputBrokerage = response.map(o => { return { id: o.Id, name: o.BrokerageName } });
              //this.userInputModel.BrokerageId = response.id;

              response.forEach(item => {
                this.userInputModel.BrokerageId.push(item.Id);

              });
            }

          });

        }
      });

    }
    else {
      this.loadUserRoles();
      this.IsAdd = true;
      this.isDisableRole = false;
      this.showUpdatePassword = false;
      this.userInputModel.UserStatus = UserStatus.Active;
      this.userInputModel.BrokerageId = null;
    }

    if (this.userInputModel.ProfilePicPath === undefined || this.userInputModel.ProfilePicPath === null || this.userInputModel.ProfilePicPath.trim().length <= 0) {
      this.userInputModel.ProfilePicPath = '/../../../assets/img/default-profile-img.png'
    }
  }

  IsNull(val) {
    if (val == null || val == "0" || val == undefined) {
      return '';
    }
    return val;
  }
  bindCity() {
    this._commonService.getCitiesList(this.userInputModel.StateId).subscribe(response => {
      this.citiesList = response.map(o => { return { Id: o.Id, Name: o.CityName }; });
    });
    this.userInputModel.CityId = 0;
  }

  firstNameValid: boolean = true;
  lastNameValid: boolean = true;
  emailValid: boolean = true;
  emailvalidation: string = "";
  passwordValid: boolean = true;
  brokerageValid: boolean = true;
  phoneValid: boolean = true;
  roleValid: boolean = true;
  userStatusValid: boolean = true;
  passwordValidation: string = "";
  linkedinValidation: string = "";

  showFNSpecCharVal = false;
  showLNSpecCharVal = false;
  specCharValMsg = '!@#$%^&*()_+\-=\[\]{};"\\|<>\/? not allowed';
  saveUser() {

    let IsValid: boolean = true;

    if (this.validationService.IsinValid(this.userInputModel.FirstName)) {
      this.firstNameValid = false;
      this.showFNSpecCharVal = false;
      IsValid = false;
    }
    else {
      if (this.validationService.isSpecialCharacterExist(this.userInputModel.FirstName)) {
        this.firstNameValid = false;
        IsValid = false;
        this.showFNSpecCharVal = true;
      }
      else {
        this.showFNSpecCharVal = false;
        this.firstNameValid = true;
      }

    }

    if (this.validationService.IsinValid(this.userInputModel.LastName)) {
      this.lastNameValid = false;
      this.showLNSpecCharVal = false;
      IsValid = false;
    }
    else {
      if (this.validationService.isSpecialCharacterExist(this.userInputModel.LastName)) {
        this.lastNameValid = false;
        IsValid = false;
        this.showLNSpecCharVal = true;
      }
      else {
        this.showLNSpecCharVal = false;
        this.lastNameValid = true;
      }
    }
    if (this.userInputModel.UserRoleId !== this.userRole.ComplianceBroker) {
      if (this.validationService.IsinValid(this.userInputModel.EmailAddress)) {
        this.emailValid = false;
        IsValid = false;
      }
      else if ((this.validationService.isEmail(this.userInputModel.EmailAddress) == false) && !this.validationService.IsinValid(this.userInputModel.EmailAddress)) {
        this.emailValid = false;
        IsValid = false;
        this.emailvalidation = "invalid Email address";
      }
      else {
        this.emailValid = true;
        this.emailvalidation = "";
      }
    }

    if ((!this.IsEditMode && (this.userInputModel.UserRoleId !== this.userRole.ComplianceBroker)) || (this.IsEditMode && (this.wasComplianceBroker && (this.userInputModel.UserRoleId !== this.userRole.ComplianceBroker)))) {
      if (this.validationService.IsinValid(this.userInputModel.Password)) {
        this.passwordValid = false;
        IsValid = false;
      }
      else {
        this.passwordValid = true;
      }
      if (this.passwordValid && this.isPassword(this.userInputModel.Password) == false) {
        IsValid = false;
        this.passwordValidation = "Must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters.";
      }
      else {
        this.passwordValidation = "";
      }
    }
    if ((this.userInputModel.UserRoleId == this.userRole.Broker ||
      this.userInputModel.UserRoleId == this.userRole.SuperAdmin ||
      this.userInputModel.UserRoleId == this.userRole.Admin
    ) && (this.isLinkedInUrlValid != null && !this.isLinkedInUrlValid)) {
      IsValid = false;
      this.linkedinValidation = "Invalid LinkedIn Url";
    }
    else {
      this.linkedinValidation = "";
    }
    //if (this.userInputModel.UserRoleId == this.userRole.DataEntryStaff) {
    //    if (this.userInputModel.BrokerageId == null) {
    //        this.brokerageValid = false;
    //        IsValid = false;
    //    }
    //}
    if (this.validationService.IsinValid(this.userInputModel.PhoneNumber)) {
      this.phoneValid = false;
      IsValid = false;
    }
    else {
      this.phoneValid = true;
    }

    if (this.validationService.IsinValid(this.userInputModel.UserRoleId)) {
      this.roleValid = false;
      IsValid = false;
    }
    else if (this.userInputModel.UserRoleId == 0) {
      this.roleValid = false;
      IsValid = false;
    }
    else {
      this.roleValid = true;
    }

    if (this.validationService.IsinValid(this.userInputModel.UserStatus)) {
      this.userStatusValid = false;
      IsValid = false;
    }
    else if (this.userInputModel.UserStatus == 0) {
      this.userStatusValid = false;
      IsValid = false;
    }
    else {
      this.userStatusValid = true;
    }

    if (IsValid) {
      if (this.validationService.isPhoneNumber(this.userInputModel.PhoneNumber) == false) {
        this._toastService.addToast({ title: 'Error Occurred', msg: 'Invalid phone number', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
        IsValid = false;
        return;
      }

      if (!this.validationService.IsinValid(this.userInputModel.Zip)) {

        if (!this.validationService.IsValidZipCode(this.userInputModel.Zip)) {
          this._toastService.addToast({ title: 'Error Occurred', msg: 'Invalid Zip Code', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
          IsValid = false;
        }
        else {
          IsValid = true;
        }
      }

      if (this.brokerRegionalLicenses != null && this.brokerRegionalLicenses.length>0) {
        let brokerageLicenseStatus = true;
        for (let i = 0; i < this.brokerRegionalLicenses.length; i++) {

          if ((this.validationService.IsinValid(this.brokerRegionalLicenses[i].StateId) || this.validationService.IsinValid(this.brokerRegionalLicenses[i].BrokerLicense)) ||
            (this.brokerRegionalLicenses[i].StateId == 0 || this.brokerRegionalLicenses[i].BrokerLicense.trim().length <= 0)) {
            brokerageLicenseStatus = false;
          }
        }

        if (!brokerageLicenseStatus) {
          this._toastService.addToast({ title: 'Error Occurred', msg: 'State and License No.	are mandatory.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
          IsValid = false;
          return;
        }
        //
        for (let i = 0; i < this.brokerRegionalLicenses.length; i++) {
          for (let j = 0; j < this.brokerRegionalLicenses.length; j++) {
            if ((i != j) && (this.brokerRegionalLicenses[i].StateId == this.brokerRegionalLicenses[j].StateId)) {
              this._toastService.addToast({ title: 'Error Occurred', msg: 'State Name can not duplicate', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
              IsValid = false;
              return;
            }
          }
        }
      }

      let CountDefaultIndex = 0;
      if (this.brokerRegionalLicenses != null) {
        for (let i = 0; i < this.brokerRegionalLicenses.length; i++) {

          if (this.brokerRegionalLicenses[i].IsDefault == true) {
            CountDefaultIndex++;
          }

          if (CountDefaultIndex > 1) {
            this._toastService.addToast({ title: 'Error Occurred', msg: 'Please select only 1 License No as Default', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
            IsValid = false;
            break;
          }
          if (!this.validationService.IsinValid(this.brokerRegionalLicenses[i].ExpiryDate_Date)) {
            if (this.brokerRegionalLicenses[i].ExpiryDate_Date.toString() == "Invalid Date") {
              this._toastService.addToast({ title: 'Error Occurred', msg: 'Please select correct date. Row No :' + (i + 1), timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
              IsValid = false;
              break;
            }
          }
        }
      }
    }

    if (IsValid) {

      if (!this.wasComplianceBroker) {
        if (this.userInputModel.UserRoleId === this.userRole.ComplianceBroker) {
          this.userInputModel.Password = null;
        }
      }

      if (this.selectedFiles.length > 0) {
        //this._toastService.addToast({ title: 'Processing', msg: 'Please wait...', timeout: 5000, theme: 'bootstrap', position: 'top-center', type: 'wait' })
        this.loaderService.display(true);
      }

      if (this.brokerRegionalLicenses != null) {
        //Converting Local Date into UTC Date
        for (let i = 0; i < this.brokerRegionalLicenses.length; i++) {

          if (!this.validationService.IsinValid(this.brokerRegionalLicenses[i].ExpiryDate_Date)) {
            let UTCDate = (this.brokerRegionalLicenses[i].ExpiryDate_Date.toUTCString());
            this.brokerRegionalLicenses[i].ExpiryDate = UTCDate;
          }
          else {

            this.brokerRegionalLicenses[i].ExpiryDate = null;
          }
        }
      }
      this.userInputModel.BrokerRegionalLicensesInputModel = this.brokerRegionalLicenses;

      if (this.userInputModel.UserStatus == UserStatus.Inactive) {
        this.IsBlocked = true;
      }

      if (this.userInputModel.UserStatus == UserStatus.Deleted) {
        this.IsDeleted = true;
      }



      if (this.userInputModel.EmailAddress) {
        if (!this.IsEditMode) {
          this.loaderService.display(true);
          this._auth0.auth0CreateUser(this.userInputModel.EmailAddress, this.userInputModel.Password, this.IsBlocked).subscribe(res => {
            res.subscribe(res => {
              if (res["user_id"]) {
                this._auth0.gerateUserResetPasswordLink(res["user_id"]).subscribe(res => {
                  res.subscribe(res => {
                    this.userInputModel.UserResetPasswordTicket = res["ticket"];
                    this._userManagerService.createUser(this.userInputModel).subscribe(response => {
                      this.userCreationResponseModel = response;
                      this.loaderService.display(false);
                      if (this.userCreationResponseModel.Success == true) {

                        if (this.selectedFiles.length > 0) {
                          this.inputFileUpload.objectId = this.userCreationResponseModel.Id;
                          this.inputFileUpload.id = this.userCreationResponseModel.Id;
                          this.uploadFiles();
                        }
                        else {
                          this.redirectToListingPage();
                        }
                      }
                      else {
                        this._toastService.addToast({ title: 'Error Occurred', msg: this.userCreationResponseModel.FailureMessage, timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
                      }
                    });
                  })
                })
              }
            });
          });
        }
        else {
          this.loaderService.display(true)
          this._auth0.auth0SearchUserByEmailId(this.userEmailID).subscribe(response => {
            response.subscribe(res => {
              if (res != null && res.length > 0 && res[0]["user_id"]) {

                this._auth0.auth0UpdateUser(res[0]["user_id"], this.userInputModel.EmailAddress, this.IsBlocked, this.IsDeleted).subscribe(res => {
                  res.subscribe(res => {
                    this._userManagerService.updateUser(this.userInputModel).subscribe(response => {
                      this.userCreationResponseModel = response;
                      this.loaderService.display(false)
                      if (this.userCreationResponseModel.Success == true) {

                        if (this.selectedFiles.length > 0) {
                          this.inputFileUpload.objectId = this.userCreationResponseModel.Id;
                          this.inputFileUpload.id = this.userCreationResponseModel.Id;
                          this.uploadFiles();
                        }
                        else {
                          this.redirectToListingPage();
                        }
                      }
                      else {
                        this._toastService.addToast({ title: 'Error Occurred', msg: this.userCreationResponseModel.FailureMessage, timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
                      }
                    });
                  });
                });
              }
              else {
                this.loaderService.display(false)
                this._toastService.addToast({ title: 'Error Occurred', msg: 'Something went wrong please try again later.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
              }
            });
          });
        }
      }
      else {
        this.userUpdateWithNoEmail()
      }
    }
  }

  userUpdateWithNoEmail() {
    if (!this.IsEditMode) {
      this._userManagerService.createUser(this.userInputModel).subscribe(response => {
        this.userCreationResponseModel = response;
        if (this.userCreationResponseModel.Success == true) {

          if (this.selectedFiles.length > 0) {
            this.inputFileUpload.objectId = this.userCreationResponseModel.Id;
            this.inputFileUpload.id = this.userCreationResponseModel.Id;
            this.uploadFiles();
          }
          else {
            this.redirectToListingPage();
          }
        }
        else {
          this._toastService.addToast({ title: 'Error Occurred', msg: this.userCreationResponseModel.FailureMessage, timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
        }
      });
    }
    else {
      this._userManagerService.updateUser(this.userInputModel).subscribe(response => {
        this.userCreationResponseModel = response;
        if (this.userCreationResponseModel.Success == true) {

          if (this.selectedFiles.length > 0) {
            this.inputFileUpload.objectId = this.userCreationResponseModel.Id;
            this.inputFileUpload.id = this.userCreationResponseModel.Id;
            this.uploadFiles();
          }
          else {
            this.redirectToListingPage();
          }
        }
        else {
          this._toastService.addToast({ title: 'Error Occurred', msg: this.userCreationResponseModel.FailureMessage, timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
        }
      });
    }
  }
  clearFeilds() {

    if (!this.IsEditMode) {
      this.router.navigate(['users/employees']);
    }
    else {
      this.router.navigate(['/employee-details'], { queryParams: { user: this.userGuid.toString() } });
    }
  }


  validateemail() {
    if ((this.validationService.isEmail(this.userInputModel.EmailAddress) == false) && !this.validationService.IsinValid(this.userInputModel.EmailAddress)) {
      this.emailValid = false;
      this.emailvalidation = "invalid Email address";
    }
    else {
      this.emailValid = true;
      this.emailvalidation = "";
    }
    if (this.validationService.IsinValid(this.userInputModel.EmailAddress)) {
      this.emailValid = false;
    }
  }
  isPassword(search: string): boolean {
    var searchfind: boolean;
    var regexp = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})");
    searchfind = regexp.test(search);
    return searchfind;

  }
  IsinValid(value: any) {

    if (value == undefined || value == '' || value == null) {
      return true;
    }
    if (value.toString().trim().length <= 0) {
      return true;
    }
    if (!value) {
      return true;
    }
    return false;
  }
  validatepassword() {
    if ((this.isPassword(this.userInputModel.Password) == false) && !this.IsinValid(this.userInputModel.Password)) {
      this.passwordValid = false;
      this.passwordValidation = "Must contain at least one number, one uppercase letter, one lowercase letter and at least 8 characters";
    }
    else {
      this.passwordValid = true;
      this.passwordValidation = "";
    }
    if (this.IsinValid(this.userInputModel.Password)) {
      this.passwordValid = false;
    }
  }
  validatechangepassword() {
    if ((this.isPassword(this.newUserPassword) == false) && !this.IsinValid(this.newUserPassword)) {
      this.passwordValid = false;
      this.passwordValidation = "Must contain at least one number, one uppercase letter, one lowercase letter and at least 8 characters";
    }
    else {
      this.passwordValid = true;
      this.passwordValidation = "";
    }
    if (this.IsinValid(this.newUserPassword)) {
      this.passwordValid = false;
    }
  }
  setDefault(event: any, index: number) {
    for (let i = 0; i < this.brokerRegionalLicenses.length; i++) {
      if (i != index) {
        this.brokerRegionalLicenses[i].IsDefault = false;
      }
    }
    if (event.target.checked) {
      this.DefaultIndexCount++;
    }
    else {
      this.DefaultIndexCount--;
    }
  }
  redirectToListingPage() {
    if (!this.IsEditMode) {
      this._toastService.addToast({ title: 'Success', msg: 'User Created Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
    }
    else {
      this.authService.reloadUserDetails(true);
      this._toastService.addToast({ title: 'Success', msg: 'User Details Updated Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
    }
    this.router.navigate(['/employee-details'], { queryParams: { user: this.userCreationResponseModel.Guid.toString() } });
  }

  onRemoveImage(id: number) {
    if (id > 0) {
      //this._toastService.addToast({ title: 'Processing', msg: 'Please wait...', timeout: 2000, theme: 'bootstrap', position: 'top-center', type: 'wait' })
      this.loaderService.display(true);
      this._userManagerService.deleteImage(id).subscribe(response => {

        if (response.toString() === 'true') {
          this._toastService.addToast({
            title: 'Success',
            msg: 'Image deleted successfully!',
            timeout: 5000,
            theme: 'bootstrap',
            position: 'bottom-right',
            type: 'success'
          });
          this.loaderService.display(false);
          this.userInputModel.ProfilePicPath = '/../../../assets/img/default-profile-img.png';
          this.imageIdToDelete = null;
          $('.profileupload')[0].hidden = false;
          this.authService.reloadUserDetails(true);
        } else {
          this._toastService.addToast({
            title: 'Error Occurred',
            msg: 'Image could not be deleted',
            timeout: 5000,
            theme: 'bootstrap',
            position: 'bottom-right',
            type: 'error'
          });
        }

      });
    }
    else {
      this._toastService.addToast({
        title: 'Success',
        msg: 'Image deleted successfully!',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'success'
      });
    }
  }

  openModalForDelete(template: TemplateRef<any>, classes, taskId: number, task: string) {
    this.deleteTask = task;
    this.deleteTaskId = taskId;
    this.modalRef = this.modalService.show(template, { class: classes });
  }
  validateExpirationDate() {
    this.isExpiryDateValidate = this.validationService.validateExpirationDate(this.brokerRegionalLicenses)
  }

  isLinkedInUrlValid: boolean;
  linkedinurlvalid(isvalid: boolean) {
    this.isLinkedInUrlValid = isvalid;
  }
  enablePasswordInput = false;
  onRoleChange() {

    if (this.userInputModel.UserRoleId === this.userRole.ComplianceBroker || this.userInputModel.UserRoleId === this.userRole.DataEntryStaff) {
      this.userInputModel.EmailAddress = null;
      this.userInputModel.Password = null;
    }


    if (this.wasComplianceBroker && (this.userInputModel.UserRoleId !== this.userRole.ComplianceBroker)) {
      this.enablePasswordInput = true;
    }

    if (this.IsEditMode && !this.enablePasswordInput) {
      if (this.userInputModel.UserRoleId !== this.userRole.ComplianceBroker && this.validationService.IsinValid(this.userInputModel.Password)) {
        this.userInputModel.Password = '***********************************************************************';
      }
    }
  }

  sendResetPassword() {
    this.loaderService.display(true);
    this._auth0.auth0SendResetPasswordLinkApi(this.userInputModel.EmailAddress).subscribe(res => {
      this._toastService.addToast({
        title: 'Success',
        msg: 'Reset password link has been sent to your email address!',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'success'
      });
      this.loaderService.display(false);
    });
    //this._auth0.auth0SendResetPasswordLinkApi(this.userInputModel.EmailAddress);
  }

  updatePassword() {
  }

  checkPasswordValidity(event) {
    if (event.key === "Enter") {
      let IsValid = true;
      if (this.validationService.IsinValid(this.newUserPassword)) {
        this.passwordValid = false;
        IsValid = false;
      }
      else {
        this.passwordValid = true;
      }
      if (this.passwordValid && this.isPassword(this.newUserPassword) == false) {
        IsValid = false;
        this.passwordValidation = "Must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters.";
      }
      else {
        this.passwordValidation = "";
      }
    }
  }

  confirmPasswordValidation = '';
  checkConfirmPasswordValidity(event) {
    if (this.confirmPassword != null && this.confirmPassword != '') {
      if (this.newUserPassword != this.confirmPassword) {
        this.confirmPasswordValidation = 'New Password and confirm password are not matching';
      }
    }
    else {
      this.confirmPasswordValidation = 'Please enter confirm password';
    }
  }

  confirmPasswordValidity = '';
  changePasswordonAdminClick() {
    this.isDisabled = true;
    let IsValid = true;
    if (this.validationService.IsinValid(this.newUserPassword)) {
      this.passwordValid = false;
      IsValid = false;
    }
    else {
      this.passwordValid = true;
    }
    if (this.passwordValid && this.isPassword(this.newUserPassword) == false) {
      IsValid = false;
      this.passwordValidation = "Must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters.";
    }
    else {
      this.passwordValidation = "";
    }

    if (IsValid) {
      if (this.confirmPassword != null && this.confirmPassword != '') {
        if (this.newUserPassword != this.confirmPassword) {
          this.isDisabled = false;
          this.confirmPasswordValidation = 'New Password and confirm password are not matching';
        }
        else {
          this.confirmPasswordValidation = '';
          this._auth0.auth0SearchUserByEmailId(this.userEmailID).subscribe(response => {
            response.subscribe(res => {
              this.loaderService.display(true);
              this._auth0.auth0UpdateUserPassword(res[0]["user_id"], this.newUserPassword).subscribe(res => {
                res.subscribe(res => {
                  this.modalRef.hide();
                  this.loaderService.display(false);
                  this.isDisabled = false;
                  if (res != null) {
                    this.forgotPasswordModel = {} as IForgotPassword;
                    this.forgotPasswordModel.Guid = this.userInputModel.UserGuid;
                    this.forgotPasswordModel.ResetPassword = this.newUserPassword;
                    this.onResetPasswordClick(this.forgotPasswordModel);
                    this._toastService.addToast({
                      title: 'Success',
                      msg: 'Password has been updated successfully!',
                      timeout: 5000,
                      theme: 'bootstrap',
                      position: 'bottom-right',
                      type: 'success'
                    });
                  }
                });
              });
            });
          });
        }
      }
      else {
        this.isDisabled = false;
        this.confirmPasswordValidation = 'Please enter confirm password';
      }
    }
  }

  ClearModel() {
    this.passwordValid = true;
    this.passwordValidation = '';
    this.confirmPasswordValidation = '';
  }


  handleKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
      let passwordStatus = this.isValidConfirmPassword();
      if (passwordStatus) {
        this.isDisabled = true;
        this.changePasswordonAdminClick();
      }
    }
  }

  focusToConfirmPassword(event: KeyboardEvent, nextId: string) {
    if (event.key === 'Enter') {
      event.preventDefault();
      let passwordStatus = this.isValidpassword();
      if (passwordStatus) {
        const nextElement = document.getElementById(nextId) as HTMLElement;
        nextElement?.focus();
      }
    }
  }

  isValidpassword() {
    if ((this.isPassword(this.newUserPassword) == false) && !this.IsinValid(this.newUserPassword)) {
      this.passwordValid = false;
      this.passwordValidation = "Must contain at least one number, one uppercase letter, one lowercase letter and at least 8 characters";

      return false;
    }
    else {
      this.passwordValid = true;
      this.passwordValidation = "";
      return true;
    }
  }

  isValidConfirmPassword() {
    if (this.confirmPassword != null && this.confirmPassword != '') {
      if (this.newUserPassword != this.confirmPassword) {
        this.confirmPasswordValidation = 'New Password and confirm password are not matching';
        return false;
      }
      else {
        this.confirmPasswordValidation = '';
        return true;
      }
    }
    else {
      this.confirmPasswordValidation = 'Please enter confirm password';
      return false;
    }
  }

  async onResetPasswordClick(forgotPasswordModel: any) {
    this.forgotPasswordService.resetPassword(forgotPasswordModel).subscribe(response => {
    });
  }

  async loadUserRoles() {
    await this._commonService.getUserRolesListForUserEntry().subscribe(response => {
      this.userRoleList = response.map(o => { return { id: o.Id, name: o.Description }; });
      if (this.userGuid != undefined) {
        if (this.authService.SuperAdmin()) {
          if ((this.userInputModel.UserRoleId === this.userRole.Admin || this.userInputModel.UserRoleId === this.userRole.SuperAdmin) && !this.userInputModel.IsDefaultSuperAdmin) {
            this.isDisableRole = false;
            this.userRoleList = this.userRoleList?.filter(f => f.id == this.userRole.SuperAdmin || f.id == this.userRole.Admin)
          }
        }
      }
      else {
        if (!this.authService.SuperAdmin()) {
          this.userRoleList = this.userRoleList?.filter(f => f.id != this.userRole.SuperAdmin)
        }
      }
    });
  }
}
